// Absolute index within the accumulated data — page-local ids collide across lazy pages.
export const withSyntheticRowIds = (rows: any[], startIndex: number): any[] =>
  rows.map((row, index) => ({
    ...row,
    _id: startIndex + index,
  }));
